import { render, staticRenderFns } from "./WordParamDetails.vue?vue&type=template&id=cf8891ee"
import script from "./WordParamDetails.vue?vue&type=script&lang=js"
export * from "./WordParamDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports